import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider } from 'wagmi';
import { RainbowKitProvider } from '@rainbow-me/rainbowkit';
import '@rainbow-me/rainbowkit/styles.css';
import './index.css';
import App from './App';
import { wagmiConfig } from './configs/wagmi';

const queryClient = new QueryClient();

// Check if Rainbow Wallet is available
const isRainbowAvailable = (): boolean => {
  if (typeof window === 'undefined') return false;
  return (window as any).ethereum?.isRainbow === true;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Conditionally wrap with RainbowKitProvider if Rainbow is detected
const AppWithProviders = () => {
  if (isRainbowAvailable()) {
    return (
      <WagmiProvider config={wagmiConfig}>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider>
            <App />
          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    );
  } else {
    return (
      <WagmiProvider config={wagmiConfig}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </WagmiProvider>
    );
  }
};

root.render(
  <React.StrictMode>
    <AppWithProviders />
  </React.StrictMode>
);
